import common from "../common.js";

export default {
  async loadUserMetrics(context, payload) {
    const responseJson = await common.getRequest(
      context,
      payload,
      "userMetric"
    );
    const responseData = [];

    for (const key in responseJson) {
      const userMetric = {
        userId: responseJson[key].userId,
        userName: responseJson[key].userName,
        lastLogin: responseJson[key].lastLogin,
        lastActivity: responseJson[key].lastActivity,
        loginsLast30Days: responseJson[key].loginsLast30Days,
        loginsLast90Days: responseJson[key].loginsLast90Days,
        loginsLast365Days: responseJson[key].loginsLast365Days,
        avgApiCallsPerDay: responseJson[key].avgApiCallsPerDay,
        numberOfSessionsToday: responseJson[key].numberOfSessionsToday,
        lastSessionLength: responseJson[key].lastSessionLength,
        averageNumberOfSessionsPerDay:
          responseJson[key].averageNumberOfSessionsPerDay,
        averageNumberOfSessionsPerMonth:
          responseJson[key].averageNumberOfSessionsPerMonth,
        averageLengthOfSessionsPerDay:
          responseJson[key].averageLengthOfSessionsPerDay,
        averageLengthOfSessionsPerMonth:
          responseJson[key].averageLengthOfSessionsPerMonth,
      };
      responseData.push(userMetric);
    }
    context.commit("setUserMetrics", responseData);
  },
};
